


















import CommonBase from "../CommonBase";
import {Component, Inject} from "vue-property-decorator";
import {NativeApi} from "../../modules/NativeBridge";
import {isAndroid, isIos, isIosWebview, isProdServer, redirect} from "../../modules/utils";

/*
 * If user browses anleggsterminal.no with iphone or android without being in the app, this will try redirecting so
 * that the url is opened in the app, or prompt the user to install app from App Store/Google Play.
 */
@Component
export default class AppRedirector extends CommonBase {
    @Inject()
    nativeApi!: NativeApi;

    readonly universalAppLink = "https://anleggsterminal.page.link/start";

    // On Android device, but not using app
    missingAndroidApp() {
        return isAndroid() && !this.nativeApi.available;
    }

    // On iOS device, but not using app
    missingIosApp() {
        return isIos() && !this.nativeApi.available && !isIosWebview();
    }

    shouldInstallAndroidApp() {
        return this.missingAndroidApp();
    }

    shouldInstallIosApp() {
        // Delay prompting for ios install like this until the neccessary app update has been out a while, since it otherwise will woork poorly for those that has the app installed.
        return this.missingIosApp() && !isProdServer;
    }

    gotoUniversalLink() {
        redirect(this.universalAppLink);
    }

    created() {
        if(this.shouldInstallAndroidApp() || this.shouldInstallIosApp()) {
            this.$emit("at-should-install-app", true);
        } else {
            this.$emit("at-should-install-app", false);
        }
    }
}
